import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ProductService} from '../../../Services/product.service';
import {Product, ProductSize} from '../../../Models/Product';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {Package} from '../../../Models/Package';
import {Price} from '../../../Models/Price';
import {Country} from '../../../../shared/Models/Country';
import {CountryService} from '../../../../translation/Services/Country.service';
import {PriceService} from '../../../Services/price.service';
import {Property} from '../../../Models/Property';
import {Grid} from '../../../../shared/Models/grid';
import {HttpParams} from '@angular/common/http';
import {BooleanColumn, TextColumn} from '../../../../shared/Models/columns';
import {TranslationFormlyService} from '../../../Services/translation.formly.service';
import {LanguageModel} from '../../../../translation/translation.models';
import {LanguageService} from '../../../../translation/Services/language.service';
import {NgForm} from '@angular/forms';
import * as _ from 'lodash';
import {ColliesFormComponent} from './collies-form/collies-form.component';
import { CookieService } from 'ngx-cookie-service';
import { createPartsModalGridConfig } from './configs';
import { PartsService } from '../../../Services/parts.service';
import { PartTableEvent } from '../../../../shared/Models/PartsTable';
import { OptionService } from '../../../Services/option.service';

export interface Stock {
  manageStock: boolean;
  EANCode: string;
  stock: string;
  lowStockTrigger: string;
  emailStockTrigger: string;
}

export interface PropertyValues {
  id: number;
  amount: number;
  name: string;
  status: boolean;
  description: string;
  check: boolean;
}

export interface PropertyStyleValues {
  id: number;
  name: string;
  position: number;
  properties: PropertyValues[];
}

export interface PackageRequest {
  packages: any;
  hasProduct: boolean;
  // packageProducts: any;
}

@Component({
  selector: 'app-view-product',
  templateUrl: './view-product.component.html',
  styleUrls: ['./view-product.component.scss']
})
export class ViewProductComponent implements OnInit {
  public product: Product = new Product();
  public productId: number;
  public prices: Price[] = [];
  public productProperties: PropertyValues[] = [];
  public productPropertiesStyles: PropertyStyleValues[] = [];
  public productPropertiesWithAmount = [];
  public productModels = [];
  public price: Price = new Price();
  public priceId = null;
  public priceCountryName;
  public countries: Country[] = [];
  public isEdit = false;
  public isEditProperty = false;
  public isEditStyleProperty = false;
  public isEditProduct = false;
  public isEditPackageProduct = false;
  public clonePackages: Package[];
  public stock: { manageStock: boolean; lowStockTrigger: string; EANCode: string; stock: string};
  public productsGrid: Grid;
  public showModal = false;
  public packageIndex: number;
  public gridParams = new HttpParams();
  private packageTranslationFields = ['name'];
  public languageMap = {};
  public selects = [];
  public languages: LanguageModel[] = [];
  public tempProducts: Product[] = [];
  public selectedProductSet = [];
  public DeleteModalIndex = 0;
  public packageItemName = '';
  public activeTab = 1;
  /** Carpets & Rugs — preset sizes, editable copy of product.productSizes (FR-006) */
  public productSizes: ProductSize[] = [];
  public isSavingSizes = false;
  @ViewChild('addPriceModal', {static: false}) addPriceModal = null;
  @ViewChild('productsModal', {static: false}) productsModal = null;
  @ViewChild('partsModal', {static: false}) partsModal = null;
  @ViewChild('partRowDetail', {static: false}) partRowDetail: TemplateRef<any>;
  // @ViewChild('addPriceForm') addPriceForm = null;
  @ViewChild('deletePriceModal', {static: false}) deletePriceModal = null;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('addPriceForm', {static: false}) addPriceForm: NgForm;
  public checkedFeild;
  public test;
  public removeSelected = [];
  public selectedId = [];
  public productAmount = 1;
  public cancelMode = false;
  @ViewChild(ColliesFormComponent, {static: false}) colliesFormComponent!: ColliesFormComponent;
  public productCollies;
  public productOptions = [];
  public selectedPartSet: number[] = [];
  public partsGrid: Grid;
  public showPartModal = false;
  public removeSelectedPart = [];
  public productHasPart = false;
  public isUpdatingPartAmount = false;
  public multipliers: Property[] = [];
  
  constructor(
    private readonly route: ActivatedRoute,
    private readonly productService: ProductService,
    private readonly countryService: CountryService,
    private readonly priceService: PriceService,
    private readonly router: Router,
    private readonly languageService: LanguageService,
    private readonly cookieService: CookieService,
    private readonly partsService: PartsService,
    private readonly optionService: OptionService,
  ) {}

  ngOnInit() {
    this.productService.getInputType().subscribe((selects) => {
      this.selects = selects.data;
    });
    this.loadMultipliers();
    this.languageService.list().subscribe(lang_resp => {
      this.languages = lang_resp.languages;
      this.languages.forEach(lang => {
        this.languageMap[lang.locale] = lang.locale;
      });
      this.route.params.subscribe(params => {
        new Promise((resolve) => {
          if (Helper.isDefined(params['id'])) {
            this.productId = params['id'];
            this.getProductPrices();
            this.productService.getProductItemForView(this.productId).subscribe(resp => {
              this.productModels = resp.models;
              this.productCollies = resp.productCollies;
              this.productPropertiesWithAmount = resp.productProperties;
              this.removeSelectedPart = resp.partProducts.map(part => part.part.id);
              this.productHasPart = resp.partProducts.length > 0;
              resp.models = resp.models.map(model => model.id);
              if (resp.packages.length === 0) {
                this.isEditPackageProduct = false;
                resp.packages.push(new Package());
              } else {
                this.isEditPackageProduct = true;
                this.prepareProductPackageOptions(resp);
              }
              resolve(resp);
            });
          }
        }).then(product => {
          this.product = (<Product>product);
          this.stock = {
            EANCode: this.product.EANCode,
            manageStock: this.product.manageStock,
            stock: this.product.stock,
            lowStockTrigger: this.product.lowStockTrigger
          };

          this.productSizes = _.cloneDeep(this.product.productSizes || []);

          const propertiesPrepared = this.preparePropertiesForThisProduct();
          this.productProperties = propertiesPrepared.general;
          this.productPropertiesStyles = propertiesPrepared.styleBase;
          // this.prepareStylePropertiesForThisProduct();

          // this.properties = this.product.productProperties;
          this.product.packages = this.product.packages.map((pack) => {
            pack.translations = TranslationFormlyService.prepareTranslationFields(
              this.packageTranslationFields, pack.translations, this.languages
            );
            pack.translationKeys = TranslationFormlyService.findTranslationKeys(pack);
            pack.translationEntries = TranslationFormlyService.findTranslationEntries(pack);
            if (Helper.isDefined(pack.packageProducts)) {
              pack.packageProducts.forEach((productItem) => {
                if (productItem.product && productItem.product.deleted === false) {
                  this.tempProducts.push(productItem);
                }
              });
            }
            return pack;
          });
          this.clonePackages = JSON.parse(JSON.stringify(this.product.packages));

          // create product options
          this.product.packages.forEach(productPackage => {
            if (productPackage && productPackage.packageProducts) {
              productPackage.packageProducts.forEach(item => {
                this.productOptions[item.id] = this.getProductOptions(item);
              });
            }
          });

        }).then(() => {
          this.countryService.list().subscribe(resp => {
            this.countries = resp.data;
          });
        });
      });
    });
  }

  getProduct() {
    return Product;
  }

  getProductPrices() {
    this.productService.getPricesOfProduct(this.productId).subscribe((resp) => {
      this.prices = resp;
    });
  }

  managePrice() {

    this.addPriceModal.show();
    this.price.product = this.productId;
    const id = (this.price.id) ? JSON.parse(JSON.stringify(this.price.id)) : null;
    if (this.isEdit) {
      delete this.price.id;
    }
    this.priceService.managePrice(this.price, this.isEdit, id).subscribe((resp) => {
      this.addPriceModal.hide();
      this.getProductPrices();
      this.productService.getProductItemForView(this.productId).subscribe(resp => {
        this.product = resp;
      });
    });
    this.addPriceForm.reset();
  }

  addPrice(price = null) {
    if (price) {
      const copyPrice = JSON.parse(JSON.stringify(price));
      this.price = copyPrice;
      this.price.country = copyPrice.country.id;
      // this.loadVats(copyPrice.country);
      this.isEdit = true;
    } else {
      this.isEdit = false;
      this.price = new Price();
    }
    this.addPriceModal.show();
  }

  ManageStock(next = true) {
    if (next) {

      if (this.colliesFormComponent.hasCollies) {
        this.colliesFormComponent.onColliesFormSubmit();
        if (this.colliesFormComponent.colliesForm.invalid) {
          return;
        }
      }

      delete this.stock.stock;
      this.productService.setStock(this.productId, this.stock).subscribe((res) => {
        this.product = JSON.parse(JSON.stringify(res));
      });
    } else {
      this.stock = {
        EANCode: this.product.EANCode,
        manageStock: this.product.manageStock,
        stock: this.product.stock,
        lowStockTrigger: this.product.lowStockTrigger
      };
    }
  }

  getProperty() {
    return Property;
  }

  ManageProductPropertyAmount(next = false) {
    const propertiesCopy = JSON.parse(JSON.stringify(this.productProperties));
    const propertiesWithStyleCopy = JSON.parse(JSON.stringify(this.productPropertiesStyles));

    propertiesCopy.map((productProperties) => {
      // TODO: implement with interface
      productProperties.property = productProperties.id;
      productProperties.amount = productProperties.amount ? productProperties.amount : '1.00';
      delete productProperties.id;
      delete productProperties.check;
      delete productProperties.name;
      delete productProperties.description;
      delete productProperties.status;
      delete productProperties.deletedAt;
      delete productProperties.code;
    });
    propertiesWithStyleCopy.map((productProperties) => {
      productProperties.properties.map((properties) => {
        properties.amount = properties.amount ? properties.amount : '1.00';
        propertiesCopy.push({
          amount: properties.amount ? properties.amount : '1.00',
          property: properties.id,
          style: productProperties.id
        });
      });
    });
    if (next) {
      this.productService.manageProperties(this.productId, {productProperties: propertiesCopy}).subscribe((res) => {
        this.product = JSON.parse(JSON.stringify(res));
        this.isEditProperty = false;
        this.productProperties.map((i) => {
          this.checkedFeild = i.check = false;
        });
        this.productPropertiesStyles.map((style) => {
          style.properties.map((property) => {
            this.checkedFeild = property.check = false;
          });
        });
      });
    }
  }

  /*
    Carpets & Rugs — preset sizes tab. A preset never carries a price (FR-017);
    it is a width × length shortcut, so the formula stays the single source of truth.
  */
  isRug() {
    return Product.isRug(this.product);
  }

  addSize() {
    this.productSizes.push({widthCm: null, lengthCm: null, position: this.productSizes.length + 1});
  }

  removeSize(index: number) {
    this.productSizes.splice(index, 1);
  }

  /** Position is the list order; it is renumbered on save, so moving is a swap */
  moveSize(index: number, offset: number) {
    const target = index + offset;
    if (target < 0 || target >= this.productSizes.length) {
      return;
    }
    const moved = this.productSizes.splice(index, 1)[0];
    this.productSizes.splice(target, 0, moved);
  }

  /** Pins each row's view to its slot so a reorder rebinds values in place instead of relying on identity-based DOM moves */
  trackByIndex(index: number): number {
    return index;
  }

  /**
   * An out-of-range product limit (Z16/D4) is checked separately below; an unset limit is
   * left unconstrained.
   *
   * D26: the API sends null, not undefined, for an unconfigured bound, so the old
   * `!== undefined` guard let `widthCm > null` through — every row on a rug without
   * limits was flagged and Save was permanently disabled. `Number.isFinite` is false for
   * both null and undefined, which is exactly "this bound is not configured".
   */
  sizeWidthOutOfRange(size: ProductSize): boolean {
    if (size.widthCm <= 0) {
      return false;
    }
    return (Number.isFinite(this.product.minWidthCm) && size.widthCm < this.product.minWidthCm)
      || (Number.isFinite(this.product.maxWidthCm) && size.widthCm > this.product.maxWidthCm);
  }

  sizeLengthOutOfRange(size: ProductSize): boolean {
    if (size.lengthCm <= 0) {
      return false;
    }
    return (Number.isFinite(this.product.minLengthCm) && size.lengthCm < this.product.minLengthCm)
      || (Number.isFinite(this.product.maxLengthCm) && size.lengthCm > this.product.maxLengthCm);
  }

  /** D26: name only the bounds that exist — an unset min printed a raw {{min}} token */
  sizeRangeKey(axis: 'width' | 'length'): string {
    return axis === 'width'
      ? Product.sizeRangeKey(axis, this.product.minWidthCm, this.product.maxWidthCm)
      : Product.sizeRangeKey(axis, this.product.minLengthCm, this.product.maxLengthCm);
  }

  /**
   * A preset either carries BOTH fixed prices or neither. A half-filled pair is a trap: it
   * reads as configured and behaves as not configured. Mirrors the server's
   * ValidProductSizeFixedPrice constraint (US-596), so the screen refuses what the API would.
   */
  sizeFixedPriceIncomplete(size): boolean {
    return this.hasFixedPrice(size.fixedDealerPrice) !== this.hasFixedPrice(size.fixedCustomerPrice);
  }

  /** Positive only, mirroring the server's Assert\Positive on both columns. */
  sizeFixedPriceNotPositive(size): boolean {
    return [size.fixedDealerPrice, size.fixedCustomerPrice]
      .some(price => this.hasFixedPrice(price) && !(Number(price) > 0));
  }

  private hasFixedPrice(price): boolean {
    return price !== null && price !== undefined && String(price).trim() !== '';
  }

  sizesAreValid() {
    return this.productSizes.every(s => s.widthCm > 0 && s.lengthCm > 0
      && !this.sizeWidthOutOfRange(s) && !this.sizeLengthOutOfRange(s)
      && !this.sizeFixedPriceIncomplete(s) && !this.sizeFixedPriceNotPositive(s));
  }

  saveSizes() {
    this.isSavingSizes = true;
    // An emptied number input leaves '' behind, which the server reads as a set value and
    // then rejects as a half-filled pair. Empty must go back as null - that is what returns
    // the size to per-m² pricing.
    const payload = this.productSizes.map((size, index) => ({
      ...size,
      position: index + 1,
      fixedDealerPrice: this.hasFixedPrice(size.fixedDealerPrice) ? size.fixedDealerPrice : null,
      fixedCustomerPrice: this.hasFixedPrice(size.fixedCustomerPrice) ? size.fixedCustomerPrice : null,
    }));
    this.productService.manageSizes(this.productId, payload).subscribe(res => {
      this.isSavingSizes = false;
      this.product.productSizes = res.productSizes || payload;
      this.productSizes = _.cloneDeep(this.product.productSizes);
    }, () => this.isSavingSizes = false);
  }

  /*
    add product to product
  */
  newPackage() {
    const pack = new Package();
    pack.translations = TranslationFormlyService.prepareTranslationFields(this.packageTranslationFields, pack.translations, this.languages);
    pack.translationKeys = TranslationFormlyService.findTranslationKeys(pack);
    pack.translationEntries = TranslationFormlyService.findTranslationEntries(pack);
    this.product.packages.push(pack);
    return true;
  }

  showDeleteBtn(packages) {
    const productSets = _.filter(packages, function (p) {
      return !p.deleted;
    });
    return productSets.length > 1;
  }


  deleteModalShow(i, packageItem) {
    this.DeleteModalIndex = i;
    this.packageItemName = packageItem.translations.name[this.cookieService.get('locale')];
    this.deleteModal.show();
  }

  removePackage(DeleteModalIndex) {
    // this.product.packages.splice(DeleteModalIndex, 1);
    this.product.packages[DeleteModalIndex].deleted = true;
    this.deleteModal.hide();
    if (this.product.packages.length === 0) {
      this.product.hasProduct = false;
    }
  }

  removeProduct(packageIndex, index) {
    // this.product.packages[packageIndex].packageProducts.splice(index, 1);
    this.product.packages[packageIndex].packageProducts[index].deleted = true;
    this.tempProducts = JSON.parse(JSON.stringify(this.product.packages[packageIndex].packageProducts));
    // chizae ke darim bade remove
    this.removeSelected.push(index);
  }

  showProductGrid(index) {
    this.showModal = true;
    this.packageIndex = index;
    const params = [];
    params.push(this.productId);
    if (Helper.isDefined(this.product.packages[this.packageIndex].packageProducts)) {
      const tmpPackageProductList = this.product.packages[this.packageIndex].packageProducts.filter((packageProduct) => !packageProduct.deleted && !packageProduct.product.deleted);
      for (const productPackage of tmpPackageProductList) {
        params.push(productPackage.product.id);
      }
    }
    this.productsModal.show();
    if (Helper.isDefined(this.product.packages[this.packageIndex].packageProducts)) {
      const temps = JSON.parse(JSON.stringify(this.product.packages[this.packageIndex].packageProducts));
      temps.forEach((temp) => {
        this.tempProducts.push(temp.product);
      });
    }


    this.productsGrid = <Grid>{
      columns: [
        <BooleanColumn>{
          name: 'doctrine.product.name',
          prop: 'item',
          type: BooleanColumn.type,
          translate: true,
          sortable: false,
        },
        <TextColumn>{
          name: 'doctrine.product.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,

        },
        <TextColumn>{
          name: 'doctrine.product.number',
          prop: 'number',
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.status',
          prop: 'status',
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return Product.PRODUCT_ACTIVE;
            }
            return Product.PRODUCT_INACTIVE;
          },
          responsiveHideCallback: (width) => width < 1024
        }
      ],
      service: this.productService,
      rememberURL: this.router.url,
      method: 'getProduct',
      defaultSort: 'position',
      rowDetailTemplate: '',
      multipleRowSearch: false,
      inPopUp: true,
      simpleSearch: true,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: false,
      params: params
    };
  }

  addToProduct() {
    this.tempProducts = [];
    this.removeSelected = [];
    this.selectedProductSet.forEach(item => {
        this.productService.getProductItemForView(item).subscribe(resp => {

          if (this.removeSelected.length > 0) {
            this.removeSelected = [];
            this.removeSelected.push(resp.id);
          }

          if (this.product.packages[this.packageIndex].packageProducts === undefined) {
            this.product.packages[this.packageIndex].packageProducts = [];
          }

          const duplicateProduct = _.find(_.filter(this.product.packages[this.packageIndex].packageProducts, (pp) => !pp.deleted && !pp.product.deleted), ['product', resp]);

          if (duplicateProduct === undefined) {
            this.product.packages[this.packageIndex].packageProducts.push({
              id: resp.id,
              name: resp.name,
              product: resp,
              amount: 1,
              dealerPrice: resp.dealerPrice,
              customerPrice: resp.customerPrice
            });

            this.productOptions[resp.id] = resp.optionProducts.map(optionProduct => ({value: optionProduct.option.id, label: optionProduct.option.name}));
          }

        });
      }
    );
    this.showModal = false;
    this.selectedProductSet = [];

    this.productsModal.hide();
  }

  redirectToList() {
    this.router.navigateByUrl('/back-office/product/overview');
  }

  managePackage() {
    const packageItem = _.filter(JSON.parse(JSON.stringify(this.product.packages)), function (p) {
      return (
        Helper.isDefined(p.id) ||
        (!Helper.isDefined(p.id) && !p.deleted));
    });
    const product = JSON.parse(JSON.stringify(this.product));
    packageItem.forEach(pack => {
      const subItem = [];
      pack.name = pack.translations.name[this.cookieService.get('locale')];
      delete pack.translationKeys;
      delete pack.translationEntries;
      if (Helper.isDefined(pack.packageProducts)) {
        pack.packageProducts.forEach((sub) => {
          if (sub.amount === undefined) {
            sub.amount = 1;
          }
          if (sub.position === undefined) {
            sub.position = 1;
          }
          if (sub.dealerPrice === undefined) {
            sub.dealerPrice = sub.product.dealerPrice;
          }
          if (sub.customerPrice === undefined) {
            sub.customerPrice = sub.product.customerPrice;
          }

          subItem.push({
            product: sub.product.id,
            amount: sub.amount,
            position: sub.position,
            dealerPrice: sub.dealerPrice,
            customerPrice: sub.customerPrice,
            package: pack.id,
            deleted: ((sub.hasOwnProperty('deleted') && sub.deleted === true) || pack.deleted === true || !product.hasProduct)
          });

        });
      }
      delete pack.id;
      pack.product = this.productId;
      pack.packageProducts = subItem;
      pack.deleted = (pack.deleted || !product.hasProduct);
      pack.translations = TranslationFormlyService.reorganizeTranslations(this.packageTranslationFields, pack.translations);
      delete pack.products;
    });
    product.packages = packageItem;
    // delete pack.packageProducts;
    const packageRequest: PackageRequest = {
      packages: product.packages,
      hasProduct: product.hasProduct,
      // packageProducts: subItem
    };
    this.productService.managePackage(packageRequest, this.productId).subscribe((resp) => {
      this.router.navigateByUrl('/back-office/product/overview');
    });
  }

  preparePropertiesForThisProduct() {
    let allProperties = [];
    const styleProperties = [];
    this.productModels.forEach((modelItem) => {
      // if (modelItem.collection.length > 0) {
      // TODO: amin fix this
      modelItem.collection.properties.forEach((property) => {
        if (property.deletedAt === null) {
          property.amount = '1.00';
          allProperties.push(property);
        }
      });

      modelItem.styles.forEach((style) => {
        style.properties.map(property => {
          if (property.deletedAt !== null) {
            style.properties.splice(property, 1);
          } else {
            property.amount = '1.00';
          }
        });
        styleProperties.push(style);
      });
      // }
    });

    allProperties = allProperties.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id);
      return (!x === true) ? acc.concat([current]) : acc;
    }, []);

    allProperties.map((prop) => {
      this.productPropertiesWithAmount.forEach((pr) => {
        if (pr.property.id === prop.id && pr.style === null) {
          prop.amount = pr.amount;
        }
      });
    });

    styleProperties.map((style) => {
      style.properties.map((property) => {
        this.productPropertiesWithAmount.forEach((pr) => {
          if (pr.style !== null) {
            if (pr.property.id === property.id && style.id === pr.style.id) {
              property.amount = pr.amount;
            }
          }
        });
      });
    });

    return {'general': allProperties, 'styleBase': styleProperties};

  }

  // prepareStylePropertiesForThisProduct() {
  //   this.productService.getProductStyleProperties(this.productId).subscribe((res) => {
  //     const productPropertyStyles = res.productPropertyStyles;
  //
  //     this.productModels.forEach((modelItem) => {
  //       modelItem.styles.forEach((style) => {
  //         style.propertyStyles.forEach((propertyStyle) => {
  //           if (productPropertyStyles.length > 0) {
  //             const propertyStyleItem = productPropertyStyles.find(x => x.propertyStyle.id == propertyStyle.id);
  //             if (propertyStyleItem) {
  //               propertyStyle.amount = propertyStyleItem.amount;
  //             }
  //
  //           }
  //         });
  //       });
  //     });
  //   });
  // }

  cancelEdit() {
    this.addPriceModal.hide();
    this.addPriceForm.reset();
  }

// fill grid
  addProduct(event) {

    /*    if (this.removeSelected.length !== 0) {
          /!*    event = this.removeSelected;*!/
          this.removeSelected.forEach(r => {
            event.splice(r, 1);
          });
          /!*      event.splice(this.removeSelected, 1);*!/
        }*/
    this.selectedProductSet = [];
    this.selectedProductSet = event;
  }


  cancelProductModel() {
    this.selectedProductSet = [];
    this.showModal = false;
    this.productsModal.hide();

  }

  sendFormOnUncheckStock($event: any) {
    if (!$event) {
      this.ManageStock(true);
    }
  }

  DisableSaveBtn(formInvalid) {
    let checkHasPackageProducts = false;

    const productSets = _.filter(this.product.packages, function (p) {
      return !p.deleted;
    });

    if (productSets.length > 0 && this.product.hasProduct) {
      productSets.forEach(pack => {
        if (!pack.packageProducts || pack.packageProducts.length === 0) {
          checkHasPackageProducts = true;
          return;
        } else {
          const productCount = _.filter(pack.packageProducts, function (product) {
            return !product.deleted;
          });
          if (productCount.length === 0) {
            checkHasPackageProducts = true;
            return;
          }
        }
      });
    }


    return formInvalid || checkHasPackageProducts || (!this.isEditPackageProduct && !this.product.hasProduct);
  }

  getProductOptions(packageProduct: any) {
    return packageProduct.product.optionProducts.map(optionProduct => ({label: optionProduct.option.name, value: optionProduct.option.id}));
  }

  changeOption(event: any, packageProduct) {
    const excludedOptionProductIds = packageProduct.product.optionProducts.filter(optionProduct => !packageProduct.selectedOptionProducts.map(({ value }) => value)
        .includes(optionProduct.id)).map(item => item.id);

    this.productService.setProductPackageExcludedOptionProducts(excludedOptionProductIds, packageProduct.id).subscribe(resp => {
    });
  }

  private prepareProductPackageOptions(resp: any) {
    resp.packages.forEach(pkg => {
      pkg.packageProducts.map(packageProduct => {
        const excludedOptionProductIds = packageProduct.excludedOptionProducts.map(({ id }) => id);
        const productOptions = packageProduct.product.optionProducts.filter(productOption => !excludedOptionProductIds.includes(productOption.id));
        packageProduct.selectedOptionProducts = productOptions.map(productOption => ({label: productOption.option.name, value: productOption.id}));
        return packageProduct;
      });
    });
  }

  addPart(event: number[]) {
    this.selectedPartSet = event;
  }

  cancelPartModel() {
    this.selectedPartSet = [];
    this.partsModal.hide();
    this.showPartModal = false;
  }

  updateProductParts() {
    this.productService.getProductItemForView(this.productId).subscribe({
      next: (resp) => {
        this.removeSelectedPart = resp.partProducts.map(part => part.part.id);
        this.productHasPart = resp.partProducts.length > 0;
        this.product.partProducts = resp.partProducts;
      }
    });
  }

  addToPart() {
    this.productService.attachPartsToProduct({parts: this.selectedPartSet.map(part => ({id: part, amount: 1, propertyID: null}))}, this.productId).subscribe({
      next: () => {
        this.updateProductParts();
      },
      complete: () => {
        this.partsModal.hide();
        this.showPartModal = false;
      }
    });
  }

  removePart(event: PartTableEvent) {
    this.productService.detachPartsFromProduct(event.partId, this.productId).subscribe({
      next: () => {
        this.product.partProducts.splice(event.index, 1);
        this.removeSelectedPart = this.product.partProducts.map(part => part.part.id);
        this.productHasPart = this.product.partProducts.length > 0;
      }
    });
  }

  updatePartAmount(event: PartTableEvent) {
    this.isUpdatingPartAmount = true;
    this.productService.attachPartsToProduct({
      parts: [{
        id: event.partId, 
        amount: event.amount,
        propertyId: this.product.partProducts[event.index].property?.id || null
      }]
    }, this.productId).subscribe({
      next: () => {
        this.product.partProducts[event.index].amount = event.amount;
      },
      error: () => {
        this.updateProductParts();
      },
      complete: () => {
        this.isUpdatingPartAmount = false;
      }
    });
  }

  showPartGrid() {
    this.partsModal.show();
    this.showPartModal = true;
    this.partsGrid = createPartsModalGridConfig(
      this.router,
      this.partsService,
      this.partRowDetail,
      this.removeSelectedPart
    );
  }

  onHasPartProductChange(event: any) {
    if (!event.target.checked && this.product.partProducts?.length > 0) {
      this.productService.attachPartsToProduct({parts: []}, this.productId).subscribe({
        next: () => {
          this.product.partProducts = [];
        },
        error: () => {
          this.updateProductParts();
        },
        complete: () => {
          this.productHasPart = false;
        }
      });
    }
  }

  loadMultipliers() {
    this.optionService.getPriceMultiplier().subscribe(response => {
      this.multipliers = response.data || [];
    });
  }

  updatePartMultiplier(event: PartTableEvent) {
    this.isUpdatingPartAmount = true;
    this.productService.attachPartsToProduct({
      parts: [{
        id: event.partId, 
        amount: this.product.partProducts[event.index].amount,
        propertyId: event.propertyId
      }]
    }, this.productId).subscribe({
      next: () => {
        const multiplier = this.multipliers.find(multiplier => multiplier.id === event.propertyId);
        if (multiplier) {
          this.product.partProducts[event.index].property = {
            id: multiplier.id,
            name: multiplier.name,
            description: multiplier.description,
            status: true,
            deletedAt: null,
            code: multiplier.code
          };
        } else {
          this.product.partProducts[event.index].property = null;
        }
      },
      error: () => {
        this.updateProductParts();
      },
      complete: () => {
        this.isUpdatingPartAmount = false;
      }
    });
  }
}
